import { PRODUCTS, PRODUCT_ROUTES } from '..';

export const STEPS_CONTENT = [
  {
    title: '1. Back & Lay',
    content: `
      <div class="driver-popover-description__step1">
        <button id="onboarding-close-btn-1" class="onboarding-close-btn"></button>
        <img
          alt="1. Back & Lay"
          src="/assets/images/onboarding/step1.png"
        />
        <div>
          <b>Back</b> - A standard bet. Back a team, player or a horse, and if they win, you win.
        </div>
        <br />
        <div>
          <b>Lay</b> - A lay bet is betting on a team, player or horse NOT winning. If you lay a horse or a team, and they lose or draw, your lay bet wins. If you place a lay bet and your selection wins, your lay bet loses.
        </div>
      </div>
    `
  },
  {
    title: '2. Odds & Liquidity',
    content: `
      <div class="driver-popover-description__step2">
        <button id="onboarding-close-btn-2" class="onboarding-close-btn"></button>
        <img
          alt="2. Odds & Liquidity"
          src="/assets/images/onboarding/step2.png"
        />
        <div>
          <b>Odds</b> - The current odds on offer for this bet. Don't like the odds on offer? Make your own offer with the odds you want and see if someone will take your bet.
          <br />
          <br />
          Not familiar with decimal odds? No worries, it's simple. For example, if you win a £10 bet at odds of 3.0, you would receive £30, which includes your original stake of £10, plus £20 of winnings.
        </div>
        <br />
        <div>
          <b>Liquidity</b> - The amount currently available to wager. Again, you can offer more, and see if another player will take the bet.
        </div>
      </div>
    `
  },
  {
    title: '3. Back Bets',
    content: `
      <div class="driver-popover-description__step3">
        <button id="onboarding-close-btn-3" class="onboarding-close-btn"></button>
        <img
          alt="3. Back Bets"
          src="/assets/images/onboarding/step3.png"
        />
        <div>
          <b>Back</b> - The odds for your bet. You can either take the odds available in the market, adjust up or down, or enter your own odds.
          <br />
          <br />
          The higher the odds, the higher the winnings.
        </div>
        <br />
        <div>
          <b>Stake</b> - For a back bet, this is the amount you will be staking, and will lose if the bet loses.
        </div>
        <br />
        <div>
          <b>Profit</b> - The amount of profit you will make if your back bet wins. Your stake will also be returned. 
        </div>
      </div>
    `
  },
  {
    title: '4. Lay Bets',
    content: `
      <div class="driver-popover-description__step4">
        <button id="onboarding-close-btn-4" class="onboarding-close-btn"></button>
        <img
          alt="4. Lay Bets"
          src="/assets/images/onboarding/step4.png"
        />
        <div>
          <b>Lay</b> - The odds for your bet. As with a back bet you can either take the odds available in the market, adjust up or down, or enter your own odds.
          <br />
          <br />
          The higher the odds, the greater the risk you take.
        </div>
        <br />
        <div>
          <b>Backer's Stake</b> - This is the amount the other player will stake, and you will win if your bet wins. 
        </div>
        <br />
        <div>
          <b>Liability</b> - The amount you will pay out to the other player if your lay bet loses.
        </div>
      </div>
    `
  },
  {
    title: '5. Matched & Unmatched',
    content: `
      <div class="driver-popover-description__step5">
        <button id="onboarding-close-btn-5" class="onboarding-close-btn"></button>
        <img
          alt="5. Matched & Unmatched"
          src="/assets/images/onboarding/step5.png"
        />
        <div>
          Not every offer you make will get matched against another player - maybe they don't like the odds you have offered, or maybe they don't want to wager so much.
          <br />
          <br />
          In this case either all, or part, of your offer will go unmatched.
          <br />
          <br />
          If this happens, you can either cancel your offer, edit either the odds or the stake, or simply wait it out. As a market fluctuates, your offer may get taken up by other players.
        </div>
      </div>
    `
  }
];

export const DRIVER_STEPS = [
  {
    element: '[data-hook="popular--event-0--runner-0"]',
    popover: {
      align: 'end',
      side: 'left',
      title: '1. Back & Lay',
      description: STEPS_CONTENT[0].content,
      nextBtnText: 'Next: 2. Odds & Liquidity',
    }
  },
  {
    element: '[data-hook="popular--event-0--runner-0"]',
    popover: {
      title: '2. Odds & Liquidity',
      align: 'end',
      side: 'right',
      description: STEPS_CONTENT[1].content,
      nextBtnText: 'Next: Back Bets',
    }
  },
  {
    element: '[data-driver="offer-0"]',
    popover: {
      title: '3. Back Bets',
      nextBtnText: 'Next: Lay Bets',
      description: STEPS_CONTENT[2].content,
    }
  },
  {
    element: '[data-driver="offer-1"]',
    popover: {
      title: '4. Lay Bets',
      nextBtnText: 'Next: Matched & Unmatched',
      description: STEPS_CONTENT[3].content,
    }
  },
  {
    element: '[data-driver="open-offer-0"]',
    popover: {
      title: '5. Matched & Unmatched',
      description: STEPS_CONTENT[4].content,
    }
  },
];

export const VIDEO_LIST = [
  {
    image: '/assets/images/onboarding/exchange-layout.jpg',
    url: 'https://www.youtube-nocookie.com/embed/mLyxX5vZQ-I',
  },
  {
    image: '/assets/images/onboarding/commissions.jpg',
    url: 'https://www.youtube-nocookie.com/embed/EYeGBUNtEao',
  },
  {
    image: '/assets/images/onboarding/exchange-vs-sportsbook.jpg',
    url: 'https://www.youtube-nocookie.com/embed/EMwttgEzwrc',
  }
];

export const RESTRICTED_PAGES = [
  '/page',
  '/promo',
  '/login',
  '/promotions',
  '/registration',
  '/reset-password',
  '/update-password',
  PRODUCT_ROUTES[PRODUCTS.mbzero],
  PRODUCT_ROUTES[PRODUCTS.casino],
  PRODUCT_ROUTES[PRODUCTS.liveCasino],
  PRODUCT_ROUTES[PRODUCTS.virtuals],
];
